import { render, staticRenderFns } from "./upload_notes_modal.vue?vue&type=template&id=5db56bc2&scoped=true"
import script from "./upload_notes_modal.vue?vue&type=script&lang=js"
export * from "./upload_notes_modal.vue?vue&type=script&lang=js"
import style0 from "./upload_notes_modal.vue?vue&type=style&index=0&id=5db56bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db56bc2",
  null
  
)

export default component.exports